import t from"eventemitter3";class r extends t{constructor(){super(),this.rootPromise={current:null},this.submitPromise={current:null}}}export{r as default};
